module.exports = __webpack_public_path__ + "img/image1-3.abebac43.png";